import actions from './actions';
import middleware from './middleware';
import operations from './operations';
import hooks from './hooks';
import eventTypes from './constants/event-types';
import initializeHandlers from './handlers/initialize-handlers';

initializeHandlers();

export default {
  actions,
  middleware,
  operations,
  hooks,
  eventTypes,
};
